module.exports = __webpack_public_path__ + "static/media/s_blue.4a4a5ad2.mp3";